module.exports = "/_next/static/images/MobileThirdProcess-112327d90e6ef12d5e8c43ab686b0016.png";